// extracted by mini-css-extract-plugin
module.exports = {"redirectMessage":"notFoundRedirect_redirectMessage__1kV9e"};